import React from 'react';

import { cn } from '@epoch-ui/lib/utils';

export type CoverPhotoProps = React.ImgHTMLAttributes<HTMLImageElement>;

/**
 * This component should be used to display cover photo in details page for an entity (e.g. event, community, etc.)
 *
 * It takes all the props that an img tag accepts.
 */
const CoverPhoto = React.forwardRef<HTMLImageElement, CoverPhotoProps>(
  ({ className, alt, ...props }, ref) => {
    return (
      <img
        ref={ref}
        alt={alt}
        className={cn(
          'tw-aspect-square tw-w-full tw-rounded-[16px] tw-object-cover tw-object-center',
          className
        )}
        {...props}
      />
    );
  }
);
CoverPhoto.displayName = 'CoverPhoto';

export { CoverPhoto };
